let createClient;
try {
  const supabaseJs = require('@supabase/supabase-js');
  createClient = supabaseJs.createClient || (supabaseJs.default && supabaseJs.default.createClient);
} catch (e) {
  console.error('[SupabaseConfig] Failed to load @supabase/supabase-js:', e);
}

export const SupabaseConfig = {
  url: process.env.REACT_APP_SUPABASE_URL || "https://ljaqxwjmglvixulmvabj.supabase.co",
  anonKey: process.env.REACT_APP_SUPABASE_ANON_KEY || "sb_publishable_zApgbyOLBa3qRQd5NG43gA_7jLajE9i",
};

export const supabase = createClient ? createClient(SupabaseConfig.url, SupabaseConfig.anonKey) : null;
